var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconModules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 15.625V23.75C5 24.7856 5.83947 25.625 6.875 25.625H23.125C24.1606 25.625 25 24.7856 25 23.75V15.625",
    stroke: "currentColor",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 9.375C3.125 8.68463 3.68464 8.125 4.375 8.125H25.625C26.3154 8.125 26.875 8.68463 26.875 9.375V14.375C26.875 15.0654 26.3154 15.625 25.625 15.625H4.375C3.68464 15.625 3.125 15.0654 3.125 14.375V9.375Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 3.33333,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.375 8.125V5.625C19.375 4.93464 18.8154 4.375 18.125 4.375H11.875C11.1846 4.375 10.625 4.93464 10.625 5.625V8.125",
    stroke: "currentColor",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 14.375V18.125",
    stroke: "currentColor",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 14.375V18.125",
    stroke: "currentColor",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModules);
export default __webpack_public_path__ + "static/media/icon-modules.f2f3d65b2c16c30bf69283026083dc42.svg";
export { ForwardRef as ReactComponent };